import React from "react";
import { Provider } from "react-redux";
import store from "App/store/store";
import AppNavigator from "App/common/AppNavigator";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import Socket from "App/common/Socket";
import OfflineBanner from "App/pwa/OfflineBanner";
import { BUTTON_COLOR } from "App/common/Colors";

const App: React.FC = () => {
  const theme = createTheme({
    palette: {
      primary: {
        main: BUTTON_COLOR,
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {},
        },
      },
    },
  });

  return (
    <div className="app">
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <OfflineBanner />
          <Socket />
          <AppNavigator />
        </ThemeProvider>
      </Provider>
    </div>
  );
};

export default App;
